export default function Benefits({ benefits }) {
  if (!benefits.length) return null;

  return (
    <section className="section section-alt benefits" style={{ marginTop: 60 }}>
      <div className="wrap">
        <p className="eyebrow">Weshalb der Aufwand sich lohnt</p>
        <h2>Ein Abend im Monat, der dir eine Fehlentscheidung erspart.</h2>
        <p className="section-lead" style={{ marginBottom: 48 }}>
          Kein Referat, kein Verkaufsstand. Wer kommt, bringt eine offene Frage mit und nimmt drei
          Antworten mit nach Hause.
        </p>

        <div className="benefit-grid">
          {benefits.map((b, i) => (
            <article className="benefit" key={b.id}>
              <span className="benefit-num">{String(i + 1).padStart(2, "0")}</span>
              <h3>{b.title}</h3>
              <p>{b.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
